// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table thead .titleWith{
    width: '179.6042px';
}

table thead .statusWith{
    width: '150.5729px';
}

table thead .actionWith{
    width: '65.0521px'!important;
}

/* Drag and Drop Styles */
.dragging {
    opacity: 0.5;
    background-color: #f8f9fa;
    transform: scale(1.02);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

tbody tr {
    transition: all 0.3s ease;
}

tbody tr:hover {
    background-color: #f8f9fa;
}

tbody tr.dragging {
    background-color: #e3f2fd;
    border: 2px dashed #2196f3;
}

.nameCol {
    cursor: pointer;
}

.nameCol:hover {
    background-color: #f8f9fa;
}

/* Drag Handle Styles */
.drag-handle {
    text-align: center;
    vertical-align: middle;
    cursor: grab;
    padding: 8px 4px;
}

.drag-handle:active {
    cursor: grabbing;
}

.drag-icon {
    font-size: 18px;
    color: #6c757d;
    opacity: 0.6;
    transition: all 0.2s ease;
}

.drag-handle:hover .drag-icon {
    opacity: 1;
    color: #495057;
}

.dragging .drag-icon {
    color: #2196f3;
    opacity: 1;
}

/* Nested Row Styles */
.parentRow {
    font-weight: 600;
}

.childRow {
    background-color: #fcfcfc;
}

.childIndicator {
    color: #b0b0b0;
    margin-right: 8px;
    font-weight: normal;
}

.childRow .nameCol {
    padding-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Category/CategoryList/CategoryList.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["table thead .titleWith{\n    width: '179.6042px';\n}\n\ntable thead .statusWith{\n    width: '150.5729px';\n}\n\ntable thead .actionWith{\n    width: '65.0521px'!important;\n}\n\n/* Drag and Drop Styles */\n.dragging {\n    opacity: 0.5;\n    background-color: #f8f9fa;\n    transform: scale(1.02);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\ntbody tr {\n    transition: all 0.3s ease;\n}\n\ntbody tr:hover {\n    background-color: #f8f9fa;\n}\n\ntbody tr.dragging {\n    background-color: #e3f2fd;\n    border: 2px dashed #2196f3;\n}\n\n.nameCol {\n    cursor: pointer;\n}\n\n.nameCol:hover {\n    background-color: #f8f9fa;\n}\n\n/* Drag Handle Styles */\n.drag-handle {\n    text-align: center;\n    vertical-align: middle;\n    cursor: grab;\n    padding: 8px 4px;\n}\n\n.drag-handle:active {\n    cursor: grabbing;\n}\n\n.drag-icon {\n    font-size: 18px;\n    color: #6c757d;\n    opacity: 0.6;\n    transition: all 0.2s ease;\n}\n\n.drag-handle:hover .drag-icon {\n    opacity: 1;\n    color: #495057;\n}\n\n.dragging .drag-icon {\n    color: #2196f3;\n    opacity: 1;\n}\n\n/* Nested Row Styles */\n.parentRow {\n    font-weight: 600;\n}\n\n.childRow {\n    background-color: #fcfcfc;\n}\n\n.childIndicator {\n    color: #b0b0b0;\n    margin-right: 8px;\n    font-weight: normal;\n}\n\n.childRow .nameCol {\n    padding-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
